import {
  APPROVE_GROUP_API,
  GET_ERROR_LOG_API,
  GROUP_CONFIGURATION_API,
  VALIDATE_APPROVAL
} from '~/constants/APIs'
import { ValidateApprovalType } from '~/models'
import axiosClient from './axiosClient'

export const groupConfigurationApis = {
  validateApproval: (groupConfigurationId: number | null) =>
    axiosClient.post(VALIDATE_APPROVAL, null, {
      params: { groupConfigurationId }
    }) as unknown as ValidateApprovalType,
  approveGroup: (groupConfigurationId: number | null) =>
    axiosClient.post(APPROVE_GROUP_API, null, {
      params: { groupConfigurationId: groupConfigurationId }
    }),
  getErrorLog: (groupConfigurationId: number | null) =>
    axiosClient.get(GET_ERROR_LOG_API, {
      params: { groupConfigurationId, downloadId: '' },
      responseType: 'blob'
    }),
  updateGroupConfigurationMandatory: (
    groupConfigurationId: number | null,
    isMandatory: boolean
  ) =>
    axiosClient.put(
      GROUP_CONFIGURATION_API + groupConfigurationId + '/mandatory',
      isMandatory,
      { headers: { 'Content-Type': 'application/json' } }
    )
}
